import React, {Component} from "react";
import {Container, Row, Col, CardGroup, Card, CardBody, Button, Input, InputGroup, InputGroupText, InputGroupAddon} from "reactstrap";
import AuthStore from '../../../stores/AuthStore';
import AuthActions from '../../../actions/AuthActions';
import connectToStores from 'alt/utils/connectToStores';

import history from '../../../history';
import Router from 'react-router';

class Login extends Component {

    static getStores() {
    return [AuthStore];
}

static getPropsFromStores() {
    return AuthStore.getState();
}

onClickLogin() {
    AuthActions.login({
      username: this.refs.formLogin.username.value,
      password: this.refs.formLogin.password.value
    });
}

  render() {
    var divError = (AuthStore.getState().error) ? (<p>{AuthStore.getState().error}</p>) : null;

    return (
    <form ref="formLogin" onSubmit={e => { e.preventDefault(); }}>
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <CardGroup className="mb-0">
                <Card className="p-4">
                  <CardBody className="card-body">
                    <h1>Login</h1>
                    <p className="text-muted">EcardioDUO</p>
                    <InputGroup className="mb-3">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText><i className="icon-user m-1"></i></InputGroupText>
                      </InputGroupAddon>
                      <Input type="text" placeholder="Username" name="username" ref="usernameInput" value={this.inputValue}/>
                    </InputGroup>
                    <InputGroup className="mb-4">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText><i className="icon-lock m-1"></i></InputGroupText>
                      </InputGroupAddon>
                      <Input type="password" placeholder="Password" name="password" ref="passwordInput" value={this.inputValue}/>
                    </InputGroup>
                    <Row>
                      <Col xs="6">
                        <Button color="primary" type="button" className="px-4" onClick={this.onClickLogin.bind(this)}>Login</Button>
                        {divError}
                      </Col>
                      <Col xs="6" className="text-right">
                        <Button color="link" className="px-0">Esqueceu a sua senha?</Button>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>

              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    </form>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js